/* eslint-disable import/prefer-default-export */

import { isNull, reduce } from 'lodash';

import { listOrderLineItemsGql } from './gql';
import graphqlClient from '../graphql';
import { transformListOrderLineItems } from './transform';

export const listOrderLineItemsApi = ({ page, sortBy, filter }) => {
  return graphqlClient
    .request(listOrderLineItemsGql, {
      offset: (page - 1) * 25,
      sortBy,
      filter: reduce(
        filter,
        (result, value, key) => ({
          ...result,
          [key]: isNull(value) ? undefined : value,
        }),
        {}
      ),
    })
    .then(transformListOrderLineItems);
};
